export function ActiveDotSvg({ x, y }: { x: number; y: number }) {
  return (
    <svg
      x={x - 22.5}
      y={y - 22.5}
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
    >
      <title>Active Dot</title>
      <g filter="url(#filter0_d_16243_83541)">
        <circle cx="22.5" cy="22.5" r="2.5" fill="#A1F900" />
        <circle cx="22.5" cy="22.5" r="4.5" stroke="#0A0A0A" strokeWidth="4" />
      </g>
      <defs>
        <filter
          id="filter0_d_16243_83541"
          x="0"
          y="0"
          width="45"
          height="45"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.141176 0 0 0 0 1 0 0 0 0 0 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16243_83541"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16243_83541"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
